export function LogoMark({ size = 34, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="NATYE"
      className={className}
    >
      <defs>
        <linearGradient id="natye-gold" x1="10" y1="8" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FBEBB6" />
          <stop offset="0.5" stopColor="#E3B94A" />
          <stop offset="1" stopColor="#BE871B" />
        </linearGradient>
      </defs>

      {/* Monogramme N — traits fins */}
      <path
        d="M13 35 L13 13 L35 35 L35 13"
        stroke="url(#natye-gold)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Étoile filante — traînée fine */}
      <path d="M30 17 L38.5 8.5" stroke="url(#natye-gold)" strokeWidth="1.4" strokeLinecap="round" opacity="0.85" />
      <path
        d="M40.2 5 L41.05 8.05 L44.1 8.9 L41.05 9.75 L40.2 12.8 L39.35 9.75 L36.3 8.9 L39.35 8.05 Z"
        fill="url(#natye-gold)"
      />
    </svg>
  );
}

export function Logo({ size = 34, showText = true, textClassName = "" }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark size={size} />
      {showText && (
        <span
          className={
            textClassName ||
            "font-heading font-light tracking-[0.32em] uppercase text-[15px] bg-gradient-to-br from-[#FBEBB6] via-[#E3B94A] to-[#BE871B] bg-clip-text text-transparent"
          }
        >
          NATYE
        </span>
      )}
    </span>
  );
}
